import { render, staticRenderFns } from "./share.vue?vue&type=template&id=504e345a&scoped=true&"
import script from "./share.vue?vue&type=script&lang=js&"
export * from "./share.vue?vue&type=script&lang=js&"
import style0 from "./share.vue?vue&type=style&index=0&id=504e345a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504e345a",
  null
  
)

export default component.exports